/* ==================================================
  Section — Hero Carousel
  Splide crossfade with auto-advance progress bar
  and prev/next arrow controls.
================================================== */

window.addEventListener('load', function () {

  const heroEl = document.querySelector('.hero-carousel');
  if (!heroEl) return;
  if (typeof Splide === 'undefined') { console.warn('Hero carousel: Splide not loaded.'); return; }

  const root      = heroEl.closest('.hero');
  const autoplay  = root.dataset.autoplay === 'true';
  const speed     = parseInt(root.dataset.autoplaySpeed, 10) || 5000;

  const prevBtn     = root.querySelector('.hero-carousel__prev');
  const nextBtn     = root.querySelector('.hero-carousel__next');
  const progressBar = root.querySelector('.hero-carousel__progress-bar');

  // ── Init Splide ──────────────────────────────────────────────
  const splide = new Splide(heroEl, {
    type         : 'fade',
    rewind       : true,
    pagination   : false,
    arrows       : false,
    drag         : true,
    speed        : 800,
    autoplay     : false,
    pauseOnHover : false,
    autoWidth    : false,
    autoHeight   : false,
  });

  // Strip inline width/height Splide sets on track, list and slides —
  // these override our CSS rules even with !important.
  function stripInlineSizes() {
    const track = heroEl.querySelector('.splide__track');
    const list  = heroEl.querySelector('.splide__list');
    if (track) { track.style.removeProperty('width'); track.style.removeProperty('height'); }
    if (list)  { list.style.removeProperty('width');  list.style.removeProperty('height'); }
    heroEl.querySelectorAll('.splide__slide').forEach(slide => {
      slide.style.removeProperty('width');
      slide.style.removeProperty('height');
    });
  }

  splide.on('mounted resize', stripInlineSizes);
  splide.mount();
  stripInlineSizes();

  // ── Progress bar helpers ─────────────────────────────────────
  function resetProgress() {
    if (!progressBar) return;
    progressBar.classList.remove('is-running');
    // Force reflow so the transition restarts cleanly
    void progressBar.offsetWidth;
  }

  function startProgress() {
    if (!progressBar || !autoplay) return;
    progressBar.classList.add('is-running');
  }

  // ── Auto-advance timer ───────────────────────────────────────
  let timer = null;

  function startTimer() {
    if (!autoplay) return;
    clearTimeout(timer);
    timer = setTimeout(() => {
      splide.go('>');
    }, speed);
  }

  function stopTimer() {
    clearTimeout(timer);
  }

  // ── On slide change ──────────────────────────────────────────
  splide.on('move', () => {
    stopTimer();
    resetProgress();
  });

  splide.on('moved', () => {
    startProgress();
    startTimer();
  });

  // ── Custom arrow controls ────────────────────────────────────
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      stopTimer();
      splide.go('<');
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      stopTimer();
      splide.go('>');
    });
  }

  // ── Pause on hover (optional UX — uncomment to enable) ───────
  // heroEl.addEventListener('mouseenter', stopTimer);
  // heroEl.addEventListener('mouseleave', () => { stopTimer(); startProgress(); startTimer(); });

  // ── Keyboard navigation ──────────────────────────────────────
  document.addEventListener('keydown', (e) => {
    if (!heroEl.closest('.hero')) return;
    if (e.key === 'ArrowLeft')  { stopTimer(); splide.go('<'); }
    if (e.key === 'ArrowRight') { stopTimer(); splide.go('>'); }
  });

  // ── Kick off ─────────────────────────────────────────────────
  startProgress();
  startTimer();

});
